import { get } from "./Config";
import config from "util/config";
import { isNewApiEnabled } from "./customerProfileFetch";
import { isCampaignWindowActive } from "../../utils/streakDisplay";

function extractResponseData(res) {
  return res?.data ?? res?.response?.data;
}

function isSuccessResultCode(code) {
  return String(code) === "20000";
}

function getNewApiBaseUrl() {
  const newApiUrl = config.config().NEW_API_URL;
  return newApiUrl && String(newApiUrl).trim() ? newApiUrl : undefined;
}

/**
 * Public endpoint — BMGM banner visibility follows kl_campaign status + period.
 * @returns {{ status: boolean, active: boolean, campaign: object|null, error: any }}
 */
export async function fetchBuyMoreGetMoreActive() {
  const empty = {
    status: false,
    active: false,
    campaign: null,
    error: null,
  };

  if (!isNewApiEnabled()) {
    return empty;
  }

  try {
    const res = await get({
      url: "/api/campaigns/buy-more-get-more/active",
      baseURL: getNewApiBaseUrl(),
      timeOut: 15000,
    });
    const data = extractResponseData(res);

    if (!isSuccessResultCode(data?.resultCode)) {
      return { ...empty, error: data };
    }

    const resultData = data.resultData ?? {};
    const campaign = resultData.campaign ?? null;
    const inWindow = isCampaignWindowActive(
      campaign?.fromDate ?? campaign?.from_date,
      campaign?.toDate ?? campaign?.to_date,
    );
    return {
      status: true,
      active: Boolean(resultData.active) && inWindow,
      campaign,
      error: null,
    };
  } catch (e) {
    console.log(
      "[buyMoreGetMore] active fetch failed >>",
      e?.response?.data || e?.message || e,
    );
    return {
      ...empty,
      error: e?.response?.data || e,
    };
  }
}
